<template>
  <div class="customer">
    <van-sticky>
      <div class="header">
        <van-icon class="vanIcon" name="arrow-left" color="#fff" @click="returnIndex" />
        <span class="addInfo">确认信息</span>
      </div>
    </van-sticky>

    <div class="cardConfirm" v-for="(item, index) in tableData" :key="index">
      <div class="facialNext">
        <div class="facialList">
          <img class="facialImg" src="../../assets/icon/me.png" alt="" style="">
          <span>{{item.projectName}}</span>
          <span>{{ item.mobile.replace(item.mobile.substr(3, 4), '****') }}</span>
          <img class="myself" src="../../assets/icon/association.png" alt="">
        </div>
        <div class="nurseName">预检台</div>
      </div>
      <div class="outpatient">
        <img class="facialImg" src="../../assets/icon/me.png" alt="">
        <span>预检台接待时间:</span>
        <span class="outName">{{item.doctorName}}</span>
      </div>
    </div>

    <div class="selectSure">确定</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      tableData: [
        {
          projectName: "张三",
          mobile: '14525878956',
          doctorName: '苏医生'
        },
        {
          projectName: "张三",
          mobile: '14525878956',
          doctorName: '苏医生'
        },
        {
          projectName: "张三",
          mobile: '14525878956',
          doctorName: '苏医生'
        },
        {
          projectName: "张三",
          mobile: '14525878956',
          doctorName: '苏医生'
        },
        {
          projectName: "张三",
          mobile: '14525878956',
          doctorName: '苏医生'
        },

      ],
    }
  },
  created() { },
  methods: {
    returnIndex() {
      this.$router.push("/customer")
    },
  },
}

</script>
<style scoped>
.facialNext {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.facialList {
  display: flex;
  align-items: center;
}

.facialImg {
  width: 1.43rem;
  margin-right: 0.3rem;
}
.outpatient {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ababb3;
  display: flex;
  align-items: center;
  margin: 0.8rem 0;
}

.myself {
  width: 2rem;
  margin-left: 0.5rem;
}
.cardConfirm {
  width: 94%;
  margin: 0.5rem auto;
  padding: 0.4rem;
  box-sizing: border-box;
  position: relative;
  background: #fff;
  border-radius: 8px;
}

.customer >>> .van-cell {
  border-bottom: 1px solid #4f89ea;
  padding: 10px 0;
  box-sizing: border-box;
}
.customer >>> .van-field__control {
  text-align: right;
}
.appointInfo {
  font-size: 0.937rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: bold;
  color: #000;
}
input {
  border: none;
  width: 95%;
  border-bottom: 1px solid #4f89ea;
  padding: 0.7rem;
  box-sizing: border-box;
  font-size: 0.937rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #bababa;
  margin-top: 0.75rem;
}
.border {
  border-radius: 10px;
  border: 1px solid #4f89ea;
}
.sticky {
  width: 90%;
  margin: 1rem auto;
  background: #fff;
  border-radius: 8px;
  padding: 0.75rem;
  box-sizing: border-box;
}
.vanIcon {
  position: absolute;
  left: 1.3rem;
}
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.selectSure {
  width: 80%;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 2.875rem;
  background: linear-gradient(122deg, #17bcc5 0%, #0164a8 100%);
  border-radius: 5rem;
  text-align: center;
  line-height: 3rem;
  font-size: 0.9375rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin: 1rem 0 1rem 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/customerReception/confirm.vue